<template>
  <div class="-mass-produce-error-state">
    <span class="-title"> Preview Failed </span>
    <div class="-try-again" @click="$emit('generate-preview')">Try Again</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.-mass-produce-error-state {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .-title {
    color: #ff3166;
    font-size: 28px;
    font-weight: 300;
    margin-bottom: 10px;
  }

  .-try-again {
    color: #06a9f4;
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
